export const pageNumberValidationError = `Please enter a valid page value.`;
export const pageNotExistValidationError = (page) => `Page ${page} does not exist.`